// extracted by mini-css-extract-plugin
export default {"savesMe":"Savings_savesMe","loading":"Savings_loading"};